var map = {
	"./Auth/Login": 343,
	"./Auth/Login.vue": 343,
	"./Component/ComponentIndex": 6227,
	"./Component/ComponentIndex.vue": 6227,
	"./News/CreateNews": 1080,
	"./News/CreateNews.vue": 1080,
	"./News/EditNews": 4553,
	"./News/EditNews.vue": 4553,
	"./News/NewsIndex": 2137,
	"./News/NewsIndex.vue": 2137,
	"./Order/CreateOrder": 6061,
	"./Order/CreateOrder.vue": 6061,
	"./Order/EditOrder": 9791,
	"./Order/EditOrder.vue": 9791,
	"./Order/OrderIndex": 382,
	"./Order/OrderIndex.vue": 382,
	"./ProformaInvoices/CreateProformaInvoice": 8762,
	"./ProformaInvoices/CreateProformaInvoice.vue": 8762,
	"./ProformaInvoices/EditProformaInvoice": 8320,
	"./ProformaInvoices/EditProformaInvoice.vue": 8320,
	"./ProformaInvoices/ProformaInvoiceIndex": 304,
	"./ProformaInvoices/ProformaInvoiceIndex.vue": 304,
	"./Section/CreateSection": 5201,
	"./Section/CreateSection.vue": 5201,
	"./Section/EditSection": 9397,
	"./Section/EditSection.vue": 9397,
	"./Section/SectionIndex": 8486,
	"./Section/SectionIndex.vue": 8486,
	"./Set/CreateSet": 8358,
	"./Set/CreateSet.vue": 8358,
	"./Set/EditSet": 8462,
	"./Set/EditSet.vue": 8462,
	"./Set/SetIndex": 2261,
	"./Set/SetIndex.vue": 2261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7110;